import apiClient from './api.ts';
import { CreateShiftInput, UpdateShiftInput } from '@/types/shift_schema.ts';

export default {
    async getAllShifts(activeOnly: boolean = false) {
        const params = activeOnly ? '?active_only=true' : '';
        return await apiClient.get(`shifts${params}`);
    },

    async getShiftById(id: number) {
        return await apiClient.get(`shifts/${id}`);
    },

    async createShift(shift: CreateShiftInput) {
        return await apiClient.post('shifts', shift);
    },

    async updateShift(id: number, shift: UpdateShiftInput) {
        return await apiClient.put(`shifts/${id}`, shift);
    },

    async deleteShift(id: number) {
        return await apiClient.delete(`shifts/${id}`);
    }
};
